import React, { memo } from 'react';
import classNames from 'classnames';
import Typography from '@lib/components/Typography/Typography';
import Trans from '@lib/components/Trans/Trans';
import styles from './StepIndicator.module.scss';

export interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

// Base width from design
// Current bar: 24 + 2 = 26px
// All other bars (active or inactive): 24 - 2 = 22px
const baseWidth = 24;
const activeExtraWidth = 0;

function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  return (
    <div className={styles.root}>
      <div className={styles.bars}>
        {Array.from({ length: totalSteps }, (_, i) => i).map((step) => {
          const isActive = step < currentStep;
          const isCurrent = step === currentStep - 1;
          const barWidth = isCurrent
            ? baseWidth + activeExtraWidth
            : baseWidth - activeExtraWidth;

          return (
            <div
              key={step}
              className={classNames(styles.bar, {
                [styles.active]: isActive,
              })}
              style={{ width: `${barWidth}px` }}
            />
          );
        })}
      </div>
      <Typography variant="body" className={styles.text}>
        <Trans
          i18nKey="step-indicator"
          values={{ current: currentStep, total: totalSteps }}
        />
      </Typography>
    </div>
  );
}

export default memo(StepIndicator);
